// import React, { useEffect, useState } from 'react';
// import { Navigate } from 'react-router-dom';

// const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
//   const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(null);

//   useEffect(() => {
//     fetch('/dashboard', { credentials: 'include' })
//       .then(res => setIsAuthenticated(res.ok))
//       .catch(() => setIsAuthenticated(false));
//   }, []);

//   if (isAuthenticated === null) return <div>Loading...</div>;

//   return isAuthenticated ? <>{children}</> : <Navigate to="/login" />;
// };

// export default ProtectedRoute;


import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import axios from 'axios';

axios.defaults.withCredentials = true;

const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isAuthorized, setIsAuthorized] = useState<boolean | null>(null);

  useEffect(() => {
    const checkAuthorization = async () => {
      try {
        const token = localStorage.getItem('token');
        const headers: Record<string, string> = {};
        if (token) {
          headers['Authorization'] = `Bearer ${token}`;
        }

        const response = await axios.get('https://rmbbackend.rmbjaipur.com/auth/admindashboard', {
          headers,
          withCredentials: true,
        });
        console.log('Dashboard API response:', response.data);

        if (response.status !== 200 || !response.data.role) {
          setIsAuthorized(false);
          return;
        }

        const roleLower = (response.data.role || '').toString().toLowerCase();
        setIsAuthorized(roleLower === 'super-admin' || roleLower === 'admin' || roleLower === 'superadmin');
      } catch (error) {
        if (axios.isAxiosError(error)) {
          console.error('Axios error:', error.response?.data || error.message);
        } else {
          console.error('Unexpected error:', error);
        }
        setIsAuthorized(false);
      }
    };

    checkAuthorization();
  }, []);

  if (isAuthorized === null) return <div>Loading...</div>;

  return isAuthorized ? <>{children}</> : <Navigate to="/login" />;
};

export default ProtectedRoute;
